<template>
    <div class="block lg:flex justify-between items-center gap-5 2xl:gap-10 text-neutral-600">
        <div class="text-2xl text-blue-800">
            <i :class="getVehicleIcon()"></i>
        </div>

        <div class="text-sm grow max-w-[160px]">
            <p><b>Veículo:</b> {{ vehicle.model }}</p>
            <p><b>Ano:</b> {{ vehicle.year }}</p>
            <p><b>Cor:</b> {{ vehicle.color }}</p>
            <p><b>Placa:</b> {{ vehicle.plate }}</p>
        </div>
        
        <div class="boxes block lg:flex items-center justify-between gap-4 grow text-sm">
            <div class="cursor-pointer grow border rounded-lg p-4 py-6 my-3 lg:my-0 text-center text-lg plan"
                :class="{ selected: selectedPlanId == plan.plan_id }"
                @click="selectPlan(plan)"
                v-for="plan in allPlans" :key="plan.plan_id"
            >
                <p class="font-bold text-blue-800 plan-name">{{ plan.plan_name }}</p>
                <p class="font-bold leading-none plan-price">{{ getTotalPrice(plan.plan_price) }}</p>
                <p class="font-semibold">{{plan.plan_months_period}} {{ plan.plan_months_period > 1 ? 'meses' : 'mês' }}</p>
                <span class="block text-center text-xs plan-period">{{ getTotalPrice(plan.plan_price / plan.plan_months_period) }} ao mês</span>
            </div>
        </div>

        <div class="block lg:flex flex-col gap-2 mt-4 lg:mt-0 text-sm">
            <p class="bg-yellow-100 my-2 lg:my-0 p-2 py-1 rounded-lg border border-yellow-300 flex flex-col" v-if="vehicle.active_equipment_rate">
                <span class="text-xs">Valor do Equipamento:</span> 
                <b>{{ getTotalPrice(vehicle.equipment_rate) }}</b>
            </p>
            <p class="bg-yellow-100 my-2 lg:my-0 p-2 py-1 rounded-lg border border-yellow-300 flex flex-col" v-if="vehicle.active_activation_rate">
                <span class="text-xs">Taxa de Ativação:</span> 
                <b>{{ getTotalPrice(vehicle.activation_rate) }}</b>
            </p>
        </div>
    </div>
</template>

<script>
import { cartStore } from '@/store/cartStore'
import stringService from '@/services/stringService';

export default {
    name: 'HiringNotExistsDashboard',
    props: {
        vehicle: {
            type: Object,
            required: true
        },
        allPlans: {
            type: Array,
            required: true
        }
    },
    computed: {
        selectedPlanId() {
            const item = cartStore().items.find(item => item.vehicle_id == this.vehicle.vehicle_id)
            return item ? item.plan_id : null
        },
    },
    methods: {
        getTotalPrice(price) {
            return stringService.formatPrice(price)
        },
        selectPlan(plan) {
            const store = cartStore()
            const isAlreadySelected = this.selectedPlanId == plan.plan_id
            
            let newItems = [...store.items]
            newItems = newItems.filter(item => item.vehicle_id != this.vehicle.vehicle_id)
            
            if (!isAlreadySelected) {
                newItems.push({
                    vehicle_id: this.vehicle.vehicle_id,
                    vehicle_model: this.vehicle.model,
                    vehicle_type: this.vehicle.vehicle_type || this.vehicle.type,
                    plan_id: plan.plan_id,
                    plan_name: plan.plan_name,
                    plan_months: plan.plan_months_period,
                    plan_price: plan.plan_price,
                    active_equipment_rate: this.vehicle.active_equipment_rate,
                    equipment_rate: this.vehicle.active_equipment_rate ? this.vehicle.equipment_rate : 0,
                    active_activation_rate: this.vehicle.active_activation_rate,
                    activation_rate: this.vehicle.active_activation_rate ? this.vehicle.activation_rate : 0
                })
            }
            
            store.setItems(newItems)
            
            if (newItems.length > 0) {
                this.$nextTick(() => {
                    document.documentElement.scrollTop = document.documentElement.scrollHeight
                })
            } else {
                document.documentElement.scrollTop = 0
            }
        },
        getVehicleIcon() {
            if (this.vehicle.vehicle_type === 'Motocicleta') {
                return 'fa-solid fa-motorcycle'
            } else if (this.vehicle.vehicle_type === 'Passeio') {
                return 'fa-solid fa-car'
            } else if (this.vehicle.vehicle_type === 'Caminhão') {
                return 'fa-solid fa-truck'
            } else {
                return 'fa-solid fa-circle-question'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.plan.selected {
    background: #1e40af;
    .plan-name {
        color: yellow;
    }
    p, span {
        color: #ffffff;
    }
}
</style>
